"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormInputXFix", {
    enumerable: true,
    get: function() {
        return FormInputXFix;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormInputGroupContext = require("./FormInputGroupContext");
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormInputXFix = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, type, align = "center" } = param;
    const group = (0, _react.useContext)(_FormInputGroupContext.FormInputGroupContext);
    const { spacers } = (0, _Theme.useTheme)();
    (0, _react.useEffect)(()=>{
        if (type === "prefix") {
            group.setHasPrefix(true);
        } else {
            group.setHasSuffix(true);
        }
    }, [
        type,
        group
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        className: _style.default.dynamic([
            [
                "d66c2b02e6e9adfc",
                [
                    {
                        top: "start",
                        bottom: "end",
                        center: "center"
                    }[align],
                    spacers.s3
                ]
            ]
        ]) + " " + (type || "")
    }, children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "d66c2b02e6e9adfc",
        dynamic: [
            {
                top: "start",
                bottom: "end",
                center: "center"
            }[align],
            spacers.s3
        ]
    }, "div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-align-self:".concat({
        top: "start",
        bottom: "end",
        center: "center"
    }[align], ";-ms-flex-item-align:").concat({
        top: "start",
        bottom: "end",
        center: "center"
    }[align], ";align-self:").concat({
        top: "start",
        bottom: "end",
        center: "center"
    }[align], ";padding:").concat(spacers.s3, "}")));
});
FormInputXFix.displayName = "FormInputXFix";

//# sourceMappingURL=FormInputXFix.js.map